import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

import { useNavigate,Outlet,Navigate } from "react-router-dom";
import { getBaseLink } from "./constants/helpers";



const ProtectedRoute = ({isAdmin=false,children }) => {

    let navigate = useNavigate();


    // const { loading, isAuthenticated, user } = useSelector((state) => state.user);
    const {user, isAuthenticated, data } = useSelector(
        (state) => state.loginData
      );


      if (isAuthenticated === false) {
          return  <Navigate to={`/user/login`} />;
      }

      if (isAdmin === true && data?.user?.roles[0]?.name !=='administrator') {
        return  <Navigate to={`/`} />;
      }

      // if (isAdmin === false && checkRole(user.roles,'user')===false) {
      //   return  <Navigate to="/login" />;
      // }

      return children ;

      
};

export default ProtectedRoute;
